const DetailTable = ({ title, children, mt = "mt-[30px]"}) => (
    <div className={`${title ?  mt:""}`}>
      {title &&<h4 className="text-[15px] mb-3 font-medium text-[#000000] ">{title}</h4>}
      <div>
        <table className="w-full  text-left text-gray-500">
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  );

  export default DetailTable;